// needs-decision-attempt-reason.ts — phase 06j review M3.
//
// The `attempt_finished` reason of a needs_decision attempt is written by the
// journal (supervisor-loop-outcome-journal.ts) and READ BACK by the `status`
// row (status-ticket-row-answered-needs-decision.ts, F-50) to find the
// question it waits on. One module for both sides: before this, each kept its
// own copy of the wording, so editing the journal text silently switched F-50
// off. Text is operator-facing (Vietnamese) and pinned by tests.

const AWAITING = "chờ người trả lời";
const AUTO_APPLIED = "đã tự áp (delegated, V2-1)";
const AWAITING_REASON = new RegExp(`^${AWAITING} câu hỏi (\\S+)$`);

/** Reason journaled for a needs_decision attempt: waiting on a human, or auto-applied by policy. */
export function needsDecisionAttemptReason(questionId: string, autoApplied: boolean): string {
  return `${autoApplied ? AUTO_APPLIED : AWAITING} câu hỏi ${questionId}`;
}

/** Question id when `reason` is the "waiting on a human" form; `undefined` for anything else (incl. auto-applied). */
export function awaitingAnswerQuestionId(reason: string): string | undefined {
  return AWAITING_REASON.exec(reason)?.[1];
}
